function getInitials(name) {
  const words = name.trim().split(" ");

  if (words.length === 1) {
    // Single word (Dhilip → DH)
    return words[0].substring(0, 2).toUpperCase();
  } else {
    // Multiple words (Dhilip Kumar → DK)
    return words
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  }
}

function stringToColor(str) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ("00" + value.toString(16)).slice(-2);
  }

  return color;
}

function getTextColor(bgColor) {
  // remove #
  const hex = bgColor.replace("#", "");

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // brightness formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness > 150 ? "#000000" : "#FFFFFF";
}

function getAvatarColors(name) {
  const bg = stringToColor(name);
  const text = getTextColor(bg);

  return {
    backgroundColor: bg,
    color: text,
  };
}
function getLast4Digits(phone) {
  if (!phone) return "";
  return phone.toString().slice(-4);
}

function getStatusColors(status) {
  const map = {
    applied: {
      bg: "#E3F2FD",
      text: "#0D47A1",
    },
    waiting: {
      bg: "#FFF8E1",
      text: "#8D6E00",
    },
    approved: {
      bg: "#E8F5E9",
      text: "#1B5E20",
    },
    rejected: {
      bg: "#FDECEA",
      text: "#B71C1C",
    },

    online: {
      bg: "#E8F5E9",    
      text: "#2E7D32",   
    },
    offline: {
      bg: "#FDECEA",   
      text: "#C62828",  
    },

    confirmed: {
      bg: "#F3E5F5",
      text: "#6A1B9A",
    },
    trip_started: {
      bg: "#E1F5FE",
      text: "#0277BD",
    },
    trip_completed: {
      bg: "#E8F5E9",
      text: "#2E7D32",
    },
    canceled: {
      bg: "#FBE9E7",
      text: "#D84315",
    },
  };

  return map[status] || {
    bg: "#EEEEEE",
    text: "#333",
  };
}

function formatDate(dateStr) {
  const date = new Date(dateStr);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 !== 0;
  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <span key={`full-${i}`} style={{ color: '#FFD700', fontSize: '20px' }}>
        ★
      </span>
    );
  }

  if (hasHalf) {
    stars.push(
      <span key="half" style={{ color: '#FBBF24', fontSize: '20px' }}>
        ⯨
      </span>
    );
  }

  while (stars.length < 5) {
    stars.push(
      <span key={`empty-${stars.length}`} style={{ color: '#D1D5DB', fontSize: '20px' }}>
        ☆
      </span>
    );
  }

  return <div style={{ display: 'flex', gap: '4px' }}>{stars}</div>;
};


export { getInitials, getAvatarColors, getLast4Digits, getStatusColors, formatDate, renderStars };
